export const ALBUMS = [
  "All Eternals Deck",
  "All Hail West Texas",
  "Beat the Champ",
  "Bleed Out",
  "Cassettes",
  "Collaborations/Compilations/Covers",
  "Dark in Here",
  "Days",
  "Full Force Galesburg",
  "Get Lonely",
  "Getting Into Knives",
  "Goths",
  "Heretic Pride",
  "In League with Dragons",
  "Jenny from Thebes",
  "Nothing for Juice",
  "Other Singles/Unreleased",
  "Singles/EPs",
  "Songs for Pierre Chuvin",
  "Sweden",
  "Tallahassee",
  "The Coroner's Gambit",
  "The Life of the World to Come",
  "The Seneca Twins",
  "The Sunset Tree",
  "Through This Fire Across From Peter Balkan",
  "Transcendental Youth",
  "We Shall All Be Healed",
  "Zopilote Machine"
]